export const defaultOrdersSettings = () => ({
    prepareTime: { min: 0, max: 0 },
    deliveryWeekdays: [],
    packageWeekdays: [],
    thresholdHour: "14:00",
    packageThresholdHour: "12:00",
    offsetPackageHours: 0,
    offsetDeliveryHours: 0,
    unknownCitiesOffsetDeliveryHours: 0,
    deliveryPrices: {},
    unknownCitiesDefaultPrice: 0,
    paymentMethodsAvailable: [],
    minimumOrderValueGlobal: 0,
    minimumOrderValueOnlinePayment: 0,
    minimumOrderValueMerchantPayment: 0
});

export const mapOrdersSettingsFromApi = (data = {}) => ({
    prepareTime: data.prepareTime || { min: 0, max: 0 },
    deliveryWeekdays: data.deliveryWeekdays || [],
    packageWeekdays: data.packageWeekdays || [],
    thresholdHour: data.thresholdHour || "14:00",
    packageThresholdHour: data.packageThresholdHour || "12:00",
    offsetPackageHours: data.offsetPackageHours || 0,
    offsetDeliveryHours: data.offsetDeliveryHours || 0,
    unknownCitiesOffsetDeliveryHours:
        data.unknownCitiesOffsetDeliveryHours || 0,
    deliveryPrices: data.deliveryPrices || {},
    unknownCitiesDefaultPrice:
        (data.unknownCitiesDeliveryPrices || {}).default || 0,
    paymentMethodsAvailable: data.paymentMethodsAvailable || [],
    minimumOrderValueGlobal: data.minimumOrderValueGlobal || 0,
    minimumOrderValueOnlinePayment: data.minimumOrderValueOnlinePayment || 0,
    minimumOrderValueMerchantPayment: data.minimumOrderValueMerchantPayment || 0
});

export const mapOrdersSettingsToApi = (settings) => ({
    prepareTime: { ...settings.prepareTime },
    deliveryWeekdays: [...settings.deliveryWeekdays],
    packageWeekdays: [...settings.packageWeekdays],
    thresholdHour: settings.thresholdHour,
    packageThresholdHour: settings.packageThresholdHour,
    offsetPackageHours: settings.offsetPackageHours,
    offsetDeliveryHours: settings.offsetDeliveryHours,
    unknownCitiesOffsetDeliveryHours: settings.unknownCitiesOffsetDeliveryHours,
    deliveryPrices: { ...settings.deliveryPrices },
    unknownCitiesDeliveryPrices: {
        default: settings.unknownCitiesDefaultPrice
    },
    paymentMethodsAvailable: [...settings.paymentMethodsAvailable],
    minimumOrderValueGlobal: settings.minimumOrderValueGlobal,
    minimumOrderValueOnlinePayment: settings.minimumOrderValueOnlinePayment,
    minimumOrderValueMerchantPayment: settings.minimumOrderValueMerchantPayment
});
